var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCubeShape03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4337 45.8887L30.3498 45.1342L48.9691 21.9544L42.0535 22.7084L23.4337 45.8887Z",
    fill: "url(#paint0_linear_173_72)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4337 45.8887L30.3498 45.1342L48.9691 21.9544L42.0535 22.7084L23.4337 45.8887Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8739 4.08897L25.7888 3.33452L48.9692 21.9543L42.0536 22.7083L18.8739 4.08897Z",
    fill: "url(#paint1_linear_173_72)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8739 4.08897L25.7888 3.33452L48.9692 21.9543L42.0536 22.7083L18.8739 4.08897Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4349 45.8885L42.0542 22.7088L18.8745 4.08948L0.255163 27.2692L23.4349 45.8885Z",
    fill: "url(#paint2_linear_173_72)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_173_72",
    x1: 40.8993,
    y1: 33.4087,
    x2: 24.3853,
    y2: 35.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C21C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73174C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_173_72",
    x1: 33.072,
    y1: 5.24071,
    x2: 35.4281,
    y2: 26.8354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C21C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73174C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_173_72",
    x1: 12.9235,
    y1: 18.3767,
    x2: 31.9601,
    y2: 33.6681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C21C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73174C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubeShape03);
export default __webpack_public_path__ + "static/media/cubeShape03.4391d96d54f484f6cf767c2fc900f2bb.svg";
export { ForwardRef as ReactComponent };